import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import { editSingleToken } from "../actions/currency";
import toast from "react-hot-toast";

// components/FormInput.jsx
function FormInput({ label, name, value, placeholder, onChange, readOnly = false, error }) {
  return (
    <div className="rp_singleinput_holder mb-3">
      <p className="rp_label mb-2">{label}</p>
      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
        <input
          type="text"
          name={name}
          className="rp_singleInput flex-grow-1"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
        />
        {error && <span className="text-danger">{error}</span>}
      </div>
    </div>
  );
}


const EditTokenModal = ({ show, handleClose, record, getTokens }) => {

  const [formvalue, setFormvalue] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormvalue(record);
  }, [record]);

  const handleChange = (e) => {
    try {
      const { name, type, value, checked } = e.target;
      const updatedValue = type === 'checkbox' ? checked : value;

      const Formvalue = { ...formvalue, [name]: updatedValue };
      setFormvalue(Formvalue);
      setErrors(validation(Formvalue));
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const validation = (formvalue) => {
    const errors = {};
  
    if (!formvalue.symbol?.trim()) {
      errors.symbol = "Token Symbol is required";
    }
  
    if (!formvalue.name?.trim()) {
      errors.name = "Token Name is required";
    }
  
    if (!formvalue.address?.trim()) {
      errors.address = "Token Address is required";
    }
  
    if (
      formvalue.decimals === undefined ||
      formvalue.decimals === "" ||
      isNaN(formvalue.decimals)
    ) {
      errors.decimals = "Decimals must be a valid number";
    }
  
    if (!formvalue.chainId || isNaN(formvalue.chainId)) {
      errors.chainId = "Valid Chain ID is required";
    }
  
    if (!formvalue.logoURI?.trim()) {
      errors.logoURI = "Token Type (logoURI) is required";
    }
  
    return errors;
  };
  


  const handleSubmit = async () => {
    try {
      const validationErrors = validation(formvalue);
      setErrors(validationErrors);
  
      if (Object.keys(validationErrors).length > 0) return;
  
      const tokenData = {
        _id: record?._id,
        name: formvalue.name,
        address: formvalue.address,
        symbol: formvalue.symbol,
        decimals: Number(formvalue.decimals),
        chainId: Number(formvalue.chainId),
        logoURI: formvalue.logoURI,
        isActive: formvalue.isActive ?? false,
      };
  
      const { status } = await editSingleToken(tokenData);
  
      if (status === "success") {
        toast.success("Token updated successfully!");
      } else {
        toast.error("Token update failed.");
      }
  
      handleClose();
      getTokens();
    } catch (err) {
      console.error("🚨 handleSubmit error:", err);
      toast.error("Something went wrong during update.");
    }
  };
  




  return (
    <>
      <Modal
        centered
        className="cmn_modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}>
        <Modal.Body>
          <div className="cmn_modal_header d-flex justify-content-between align-items-center">
            <p className="cmn_modal_title">Edit Pairs</p>
            <button className="cmn_modal_closer rounded-5" onClick={handleClose}>
              <i class="fa-solid fa-xmark" />
            </button>
          </div>


          <div className="mt-4">
            {/* Pair Name */}
            <FormInput label="Token Name" name="name" value={`${formvalue?.name}`} placeholder="Name" onChange={handleChange} readOnly />

            {/* Base Token Address */}
            <FormInput label="Address" name="address" value={formvalue?.address} placeholder="Address" readOnly />

            {/* Pair Symbol */}
            <FormInput label="Token Symbol" name="symbol" value={formvalue?.symbol} placeholder="Symbol" onChange={handleChange} />


            {/* Base Token Decimals */}
            <FormInput label="Decimals" name="Decimal" value={formvalue?.decimals} placeholder="Decimals" onChange={handleChange} error={errors?.decimals} />

            {/* Chain ID */}
            <FormInput label="Chain ID" name="chainId" value={formvalue?.chainId} placeholder="Chain ID" readOnly error={errors?.chainId} />

            {/* Type */}
            <FormInput label="Logo URL" name="type" value={formvalue?.logoURI} placeholder="Contract Type" onChange={handleChange} error={errors?.logoURI} />
            

            {/* Show Token Toggle */}
            <div className="rp_singleinput_holder mb-3">
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-between align-items-center gap-2">
                <p className="rp_label mb-0">Show the Token</p>
                <div className="showAndHideToggle">
                  <input type="checkbox" name="isActive" checked={formvalue?.isActive} onChange={handleChange} />
                  <label></label>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <button className="orange_small_primary mt-3" onClick={handleSubmit}>
              Submit
            </button>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditTokenModal;
